var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestReview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 19.4998H12.6667C12.8667 19.8415 13.1083 20.1582 13.375 20.4415C13.075 20.8832 12.575 21.1665 12 21.1665C11.558 21.1665 11.134 20.9909 10.8215 20.6783C10.5089 20.3658 10.3333 19.9419 10.3333 19.4998ZM4.5 18.6665V17.8332L6.16667 16.1665V11.1665C6.16634 9.91003 6.57172 8.68704 7.32248 7.67952C8.07324 6.67201 9.12924 5.93383 10.3333 5.57484V5.33317C10.3333 4.89114 10.5089 4.46722 10.8215 4.15466C11.134 3.8421 11.558 3.6665 12 3.6665C12.442 3.6665 12.866 3.8421 13.1785 4.15466C13.4911 4.46722 13.6667 4.89114 13.6667 5.33317V5.57484C14.8708 5.93383 15.9268 6.67201 16.6775 7.67952C17.4283 8.68704 17.8337 9.91003 17.8333 11.1665V12.0665L17 11.9998L16.1667 12.0665V11.1665C16.1667 8.8665 14.3 6.99984 12 6.99984C9.7 6.99984 7.83333 8.8665 7.83333 11.1665V16.9998H12C12 17.5832 12.1 18.1415 12.2833 18.6665H4.5Z",
    fill: "#1B1B20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 3.5,
    fill: "#FA8701"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8498 15.5H17V17.9872L18.3992 19.5L19 18.8504L17.8498 17.6068V15.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestReview);
export default __webpack_public_path__ + "static/media/requestReview.e5590af6.svg";
export { ForwardRef as ReactComponent };